module.exports = __webpack_public_path__ + "static/media/ashmore-ellis-photo-2.77334c45.jpg";